import styled from "styled-components";

export const HeroImg = styled.img`
    width: 100%;
    height: auto;
`;
